import { render } from "./EntriesEC.vue?vue&type=template&id=480a881a"
import script from "./EntriesEC.vue?vue&type=script&lang=js"
export * from "./EntriesEC.vue?vue&type=script&lang=js"

import "./EntriesEC.vue?vue&type=style&index=0&id=480a881a&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__